import { SimulationPolicyComplianceConstraintType } from '@warebee/shared/engine-model';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { getAllocationConstraints } from '../store/allocation/allocation.helper';

export const useViolationConstraintOptions = () => {
  const { t } = useTranslation('simulation');

  const constraintTitles = getAllocationConstraints(t);

  const violationConstraintOptions = _.reduce(
    Object.values(SimulationPolicyComplianceConstraintType),
    (acc, type) => ({
      ...acc,
      [type]: constraintTitles[type],
    }),
    {
      '': t('All', { ns: 'simulation' }),
    },
  ) as Record<string, string>;

  return violationConstraintOptions;
};
